import * as Yup from 'yup'

const passwordValidationSchema = Yup.object().shape({
  currentPassword: Yup.string().required(),
  newPassword: Yup.string()
    .required()
    .min(8)
    .test(
      'has-a-number-at-least',
      { key: 'user-zone:password-must-have-a-number' },
      value => /\p{Decimal_Number}/u.test(value),
    )
    .test(
      'has-an-uppercase-letter-at-least',
      { key: 'user-zone:password-must-have-an-uppercase-letter' },
      value => /\p{Uppercase_Letter}/u.test(value),
    ),
  confirmNewPassword: Yup.string()
    .required()
    .test(
      'matches-new-password',
      { key: 'user-zone:passwords-dont-match' },
      async (value, testContext) => testContext.parent.newPassword === value,
    ),
})

export default passwordValidationSchema
